import React from "react";
import EntryFlowController from "./EntryFlowController";

export default function EntryFlowRoute({ source, nameseo, code, location }) {
  return (
    <EntryFlowController
      source={source}
      nameseo={nameseo}
      code={code}
      location={location}
    />
  );
}

